
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/stores/breitling-boutiques/[country]",
      function () {
        return require("private-next-pages/[lang]/stores/breitling-boutiques/[country]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/stores/breitling-boutiques/[country]"])
      });
    }
  